import { Divider } from 'antd';
import { useIntl } from 'react-intl';
import PropTypes from '../../../../../../../utils/propTypes';

const LayoutHeader = ({ template, supplier }) => {
  const intl = useIntl();
  return (
    <div className="row">
      <div className="col-xs-12">
        <p
          style={{
            fontSize: '1.1em',
            fontWeight: 500,
            textTransform: 'uppercase',
            marginBottom: 10,
          }}
        >
          <strong>
            {intl.formatMessage({ id: 'layoutHeader.templateName' })}
          </strong>
          : {template}
        </p>
        <p
          style={{
            fontSize: '1.1em',
            fontWeight: 500,
            textTransform: 'uppercase',
            marginBottom: 10,
          }}
        >
          <strong>{intl.formatMessage({ id: 'layoutHeader.supplier' })}</strong>
          : {supplier}
        </p>
        <Divider />
      </div>
    </div>
  );
};

LayoutHeader.propTypes = {
  template: PropTypes.string,
  supplier: PropTypes.string,
};

LayoutHeader.defaultProps = {
  supplier: '--',
  template: '--',
};

export default LayoutHeader;
